// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__17L4b","colMaxWidth":"Table_colMaxWidth__WdcSl"};